module.exports = __webpack_public_path__ + "img/radiometro-uv.e138b9ed.webp";